import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { createAccountLink, NewAccountLinkData } from '../api'
import { usePortalMutation } from 'src/Libs/api'

interface UseCreateAccountLinkParams {
  onSuccess?: (vars: CreateAccountLinkVariables) => void
  onError?: (vars: CreateAccountLinkVariables) => void
}

interface CreateAccountLinkVariables {
  installationId: number
  payload: NewAccountLinkData
}

type UseDeleteSystemReturnType = (data: UseCreateAccountLinkParams) => UseMutationResult<void | null, unknown, CreateAccountLinkVariables>

/**
 * Hook to create an account link for specific installation
 */
export const useCreateAccountLink: UseDeleteSystemReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation({
    mutationFn: ({ installationId, payload }) => createAccountLink({ authFetch, data: payload, installationId }),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })
}
